var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrivacy24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.354 3.646a.5.5 0 010 .708L8.558 16.15a.5.5 0 01-.098.097l-4.106 4.107a.5.5 0 01-.708-.708l3.726-3.726c-.949-.7-2.2-1.905-3.74-3.579a.5.5 0 01-.023-.65C6.314 8.307 9.11 6.5 12 6.5c1.27 0 2.525.35 3.762 1.03l3.884-3.884a.5.5 0 01.708 0zM9.914 13.38L8.09 15.204c-.804-.566-1.942-1.629-3.427-3.223C7.194 8.924 9.642 7.5 12 7.5c.994 0 2 .252 3.022.77L13.38 9.915a2.5 2.5 0 00-3.464 3.464zm.732-.732l2-2a1.5 1.5 0 00-2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.839 9.84a.5.5 0 01.707-.016c.413.395.838.801 1.817 1.835a.5.5 0 01.027.656c-2.704 3.38-5.5 5.185-8.39 5.185-.182 0-.364-.007-.545-.021a.5.5 0 01.079-.997c.155.012.31.018.466.018 2.357 0 4.804-1.421 7.334-4.472-.75-.785-1.117-1.135-1.475-1.477l-.004-.005a.5.5 0 01-.016-.706z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy24);
export default __webpack_public_path__ + "static/media/icon-privacy-24.f0438543.svg";
export { ForwardRef as ReactComponent };